import { IModel } from '@pia/pia.shared';
import { Paginated } from '@feathersjs/feathers';
import { IGenericStorage } from 'src/app/shared/services/contracts/database/generic-storage';
import { IQuery } from 'src/app/shared/services/contracts/query/query';
import { IFeathersAppProvider } from 'src/app/shared/services/contracts/sync/feathers-app-provider';

import { DbQueryStrategy } from './db-query-strategy';

export class RemoteQueryStrategy<T extends IModel & {}> extends DbQueryStrategy<T> {
  constructor(databaseName: string, storage: IGenericStorage, feathersAppProvider: IFeathersAppProvider, user) {
    super(databaseName, storage, feathersAppProvider, user);
  }

  public async getAll(): Promise<T[]> {
    const result = await this.feathersAppProvider.app
      .service(this.table)
      .find(this.getParamsWithAuth(this.user, { query: { $paginate: false } }));

    return this.isPaginated(result) ? result.data : result;
  }

  public async getItems(keys: string[]): Promise<any[]> {
    const result = await this.feathersAppProvider.app
      .service(this.table)
      .find(this.getParamsWithAuth(this.user, { query: { _id: { $in: keys }, $paginate: false } }));

    return this.isPaginated(result) ? result.data : result;
  }

  public async get(id: string): Promise<T> {
    try {
      const result = await this.feathersAppProvider.app.service(this.table).get(id, this.getParamsWithAuth(this.user));

      return result;
    } catch (e) {
      return void 0;
    }
  }

  public async searchInternal(ids: string[], query: IQuery): Promise<T[]> {
    const params = {
      query: {
        _id: { $in: ids },
        archived: this.withArchive.includes(this.table) ? undefined : { $ne: true },
        $paginate: false,
      },
    };

    if (query.ignoreRegionIds) {
      params.query['$ignoreRegionIds'] = true;
    }

    const result = await this.feathersAppProvider.app
      .service(this.table)
      .find(this.getParamsWithAuth(this.user, params));

    return this.isPaginated(result) ? result.data : result;
  }

  private isPaginated(paginated: any[] | Paginated<any>): paginated is Paginated<any> {
    return paginated && (paginated as Paginated<any>).data !== undefined;
  }
}
